import { useState, useEffect } from 'preact/hooks';
import { riperStorage } from '@/base/helpers';

export default function useTemplet({ ruleUid }) {
  const [state, setState] = useState({
    templet: riperStorage.templets[ruleUid],
    templetError: false,
    templetLoading: true,
  });

  function handleError(error) {
    console.log(error);
    setState({
      ...state,
      templetLoading: false,
      templetError: true,
    });
  }

  useEffect(() => {
    let query = null;
    if (ruleUid === 'rule:bamboo:display' && riperStorage.args.bambooPageLocalTemplet) {
      query = fetch(riperStorage.args.bambooPageLocalTemplet).then((response) => response.json());
    } else {
      query = new Promise((resolve) => {
        resolve(riperStorage.templets[ruleUid]);
      });
    }
    query
      .then((templet) => {
        setState({
          templet,
          templetError: false,
          templetLoading: false,
        });
      })
      .catch(handleError);
  }, []);

  return state;
}
